import React, { useContext, useEffect, useState } from 'react';
import { getLiveDetails } from "../../../../api/index.js";
import { useDispatch, useSelector } from "react-redux";
import { GET_LIVE_DETAILS } from "../../../../constants/actionTypes.js";
import { ThemeContext, useTheme } from '../../../ThemeContext.js';
import { themes } from '../../../themes/themes.js';
import { useLocation } from 'react-router-dom';

export const useLiveResolver = (id, mode, date, competition) => {

    const dispatch = useDispatch()

    const { theme, changeTheme } = useTheme();

    const live = useSelector((state) => state.live);

    // Récupérer les query params (ex: ?tags=123,456)
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Récupérer les tags du query param (?tags=123,456)
    const tags = queryParams.get("tags")?.split(",") || []; // Convertir en tableau d'IDs ou un tableau vide


    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await getLiveDetails(id, mode, date, competition, tags);
            dispatch({ type: GET_LIVE_DETAILS, payload: response.data})
          } catch (error) {
            console.error(error);
          }
        };
    
        fetchData();
      }, [id, date, competition, mode]);

    useEffect(() => {
      console.log(live)
      changeTheme(themes[live.provider] ?? themes['default']);
    }, [live])

      return [live]
}